import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ThreeDots } from '../../../../common/Placeholders.jsx';
import { getCollectionArrangementPlaylists } from '../../../../../actions/collection';
import NewPlaylistForm from './NewPlaylistForm.jsx';
import PlaylistsCheckbox from './PlaylistsCheckbox.jsx';


const PlaylistsModal = ({ show, onClose, inPlaylists, offerId, playlists, onPlaylistChange,
                                    getCollectionArrangementPlaylists }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCollectionArrangementPlaylists(offerId).then(() => setIsLoading(false));
  },[]);

  const handlePlaylistChange = (playlistId, checked) => {
    onPlaylistChange(offerId, playlistId, checked);
  }

  let playlistCheckboxes;
  if (playlists.length){
    playlistCheckboxes = playlists.map(i => <PlaylistsCheckbox key={ i.id } playlist={ i }
                                                               onChange={ handlePlaylistChange }
                                                               checked={ inPlaylists ? inPlaylists.includes(i.id)
                                                                                     : false }/>)
  }

  return(
    <Modal show={ show } onHide={ onClose } size='md'>
      <Modal.Header closeButton>
        <Modal.Title>
          { gettext('Выберите плейлисты') }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { isLoading ? <ThreeDots/> : playlistCheckboxes }
        <NewPlaylistForm/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ onClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

PlaylistsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  inPlaylists: PropTypes.arrayOf(PropTypes.number).isRequired,
  offerId: PropTypes.number.isRequired,
  onPlaylistChange: PropTypes.func.isRequired,
  getCollectionArrangementPlaylists: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    playlists: state.collection.playlists
  }
};

export default compose(
  connect(mapStateToProps, { getCollectionArrangementPlaylists }),
)(PlaylistsModal);
